module.exports = __webpack_public_path__ + "static/media/coxinhasemfundo.8efd8431.webp";